import useTranslate from "ui/locale/hooks/useTranslate";
import useUsersStats from "features/users/hooks/useUsersStats";

export default function useUsersChart() {
    const translate = useTranslate();
    const { data: stats, isLoading } = useUsersStats();

    return { title: translate("users"), stats, isLoading };
}
